import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import OutsideClickHandler from "react-outside-click-handler";
import { NavLink } from "react-router-dom";

import { useMe } from "../../../../../hooks/queries";

import "./styles.scss";

export interface IListLocationsProps {
  locations: {
    id: number;
    name: string;
  }[];
}

export const ListLocations: React.FC<IListLocationsProps> = ({ locations }) => {
  const { data: me } = useMe();
  const { t: _t } = useTranslation();
  const t = (key: string, params?: any) =>
    _t(`adminLocationAlertsPage.adminLocationAlertsList.${key}`, params);

  const [displayLocations, setDisplayLocations] = useState(false);
  return (
    <div className="list-locations">
      <OutsideClickHandler onOutsideClick={() => setDisplayLocations(false)}>
        <button onClick={() => setDisplayLocations(!displayLocations)}>
          {t("num_locations", { count: locations.length })}
        </button>
        {
          <div
            className={`facility-list-container ${
              displayLocations ? "facility-list-container-show" : ""
            }`}
          >
            <div className="facility-list">
              {locations?.map((loc) => (
                <NavLink
                  key={loc.id}
                  to={`/location/${loc.id}/${
                    me ? `organization/${me.organization_id}` : ""
                  }`}
                >
                  {loc.name}
                </NavLink>
              ))}
            </div>
          </div>
        }
      </OutsideClickHandler>
    </div>
  );
};
